import Handlebars from 'hbs';
/* Templates */
import ConfirmPopupTemplate from '../../templates/components/confirm-popup/popup.html';


export default class ConfirmPopup {

    /* Constructor */
    constructor(popupText, popupCtaUrl) {

        this.confirmPopupTemplate = ConfirmPopupTemplate;
        this.popupText = popupText;
        this.popupCtaUrl = popupCtaUrl;
        this.init();
        this.events();

    }


    init() {

        var $this = this;

        $this.isRedirectOnClose = false;
        
        if ($('#confirm-popup-wrapp').length) {
            $('#confirm-popup-wrapp').remove();
        }

        
        //For P5 local testing, local we are still using p5 headers 
        //$($this.confirmPopupTemplate).insertAfter("footer#footer");
        if ($("footer.footer").length > 0) {

            $($this.confirmPopupTemplate).insertAfter("footer.footer");

        }

        if ($("footer#footer").length > 0) {

            $($this.confirmPopupTemplate).insertAfter("footer#footer");
            
        }


        $($this.confirmPopupTemplate).insertAfter("footer.footer");

        $('#confirm-popup-wrapp .c_desc').html($this.popupText);

    }

    events() {

        var $this = this;

        $('.confirm-poppup .c-btn-cta').off('click').on('click', function(event) {
            event.preventDefault();
            $('.confirm-poppup').hide();
            $('.s-layer-dimmed').hide();
            
            if (!$this.isRedirectOnClose) {

                window.open($this.popupCtaUrl, '_blank');
            
            } else {

                $this.redirectPage();

            }

            
        });

        $('.confirm-poppup #confirm-popup-close').off('click').on('click', function(event) {

            $('.confirm-poppup').hide();
            $('.s-layer-dimmed').hide();
            $this.redirectPage();

        });


        $(document).mouseup(function(e) {
    
            var container = $('.confirm-poppup');
            // if the target of the click isn't the container nor a descendant of the container
            if (container.is(':visible') && !container.is(e.target) && container.has(e.target).length === 0) 
            {
                container.hide();
                $('.s-layer-dimmed').hide();
                $this.redirectPage();
            }

        });

    }

    redirectPage() {

        var $this = this;
        
        if ($this.isRedirectOnClose) {

            window.location.href = $this.popupCtaUrl;
        
        }
    
    }

    setRedirectOnClose(isRedirectOnClose) {

        var $this = this;
        
        $this.isRedirectOnClose = isRedirectOnClose;
        //console.log('popup redirect close', $this.isRedirectOnClose);

    }

    showConfirmPopup() {

        $('.confirm-poppup').show();
        $('.s-layer-dimmed').css('opacity', 0.8);
        $('.s-layer-dimmed').show();
    }

}

